class Service {
    init(store) {
        this.store = store;
    }

    getReducerName() {
        throw new Error('getReducerName not implemented');
    }

    getState() {
        return this.store.getState();
    }

    getReducerState() {
        return this.getState()[this.getReducerName()];
    }

    getReducer() {
        throw new Error('getReducer not implemented');
    }
}

export default Service;
